import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/pickup_locations',
  component: Management,
  redirect: '/pickup_locations/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/pickup_locations/List'),
      meta: {
        auth: Auth.listPickupLocations
      }
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/pickup_locations/New'),
      meta: {
        auth: Auth.createPickupLocation
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/pickup_locations/Edit'),
      meta: {
        auth: Auth.updatePickupLocation
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/pickup_locations/DetailLayout'),
      meta: {
        auth: Auth.showPickupLocation
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/pickup_locations/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showPickupLocation
          }
        }
      ]
    }
  ]
}
